import { NgModule } from '@angular/core';
import { TgSvgModule } from '@trademe/tangram';
import { TmPageNotFoundIllustrationComponent } from './tm-page-not-found-illustration.component';

@NgModule({
    declarations: [TmPageNotFoundIllustrationComponent],
    imports: [TgSvgModule],
    exports: [TmPageNotFoundIllustrationComponent]
})
export class TmPageNotFoundIllustrationModule {}
